import { render } from "./ManagementApproach.vue?vue&type=template&id=1b10d065&scoped=true"
import script from "./ManagementApproach.vue?vue&type=script&lang=js"
export * from "./ManagementApproach.vue?vue&type=script&lang=js"

import "./ManagementApproach.vue?vue&type=style&index=0&id=1b10d065&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b10d065"]])

export default __exports__